import { render, staticRenderFns } from "./TSiteRoaming.vue?vue&type=template&id=efbc0514&"
import script from "./TSiteRoaming.vue?vue&type=script&lang=js&"
export * from "./TSiteRoaming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports